import React from 'react';
import { Icon } from '@chakra-ui/react';

export const SvgPencilIcon = (props) => {
  return (
    <Icon viewBox="0 0 13 13" {...props}>
      <path
        fill="white"
        d="M13.847 3.53L11.5 1.183a.494.494 0 0 0-.352-.144h-.014a.558.558 0 0 0-.377.165l-8.5 8.5a.4.4 0 0 0-.1.172l-1.13 3.786c-.046.153.187.346.319.346a.1.1 0 0 0 .025 0c.112-.026 3.2-.954 3.788-1.13a.4.4 0 0 0 .168-.1l8.5-8.5a.558.558 0 0 0 .163-.359.5.5 0 0 0-.141-.385zm-9.019 8.592c-.879.264-1.978.6-2.738.823l.817-2.738z"
        transform="translate(-0.51 -0.52)"
      />
    </Icon>
  );
};
